import { ValidationResult } from './interfaces';
import { PersonNameDTO, WorkGeoLocationPointDTO } from '../../api/core';

export function validateRequired(data: unknown): ValidationResult {
  if ((typeof data === 'string' || data instanceof String) && data === '') {
    return {valid: false, reason: 'validated:required:emptyString'};
  }
  if (data === null) {
    return {valid: false, reason: 'validated:required:null'};
  }
  if (data === undefined) {
    return {valid: false, reason: 'validated:required:undefined'};
  }
  if (data === false) {
    return {valid: false, reason: 'validated:required:false'};
  }
  if (Array.isArray(data) && data.length === 0) {
    return {valid: false, reason: 'validated:required:emptyArray'};
  }
  return {valid: true};
}

export function validateIssuedLength(data: number): ValidationResult {
  const length: number = (data || '').toString().length;
  if (length === 0) return {valid: true};
  if (length !== 8) return {valid: false, reason: 'validated:length'};
  const day: string = data.toString().substring(6, 8);
  const month: string = data.toString().substring(4, 6);
  const year: string = data.toString().substring(0, 4);
  if (day === '00' && month === '00') return {valid: true};
  if (isNaN(Date.parse(`${year}/${month}/${day}`))) return {valid: false, reason: 'validated:invalidDate'};
  return {valid: true};
}

export function validateOneMainName(data: PersonNameDTO[]): ValidationResult {
  const isMains: number = data.filter((names: PersonNameDTO): boolean => names.isMain).length;
  if (isMains === 1) {
    return {valid: true};
  }
  return {valid: false, reason: isMains < 1 ? 'validated:noMainName' : 'validated:toManyMainNames'};
}

export function validateMinGeoLocationPoints(data: WorkGeoLocationPointDTO[]): ValidationResult {
  if (data.length < 4) {
    return {valid: false, reason: 'validated:amount:geoLocationPoints'};
  }
  return {valid: true};
}

export function validateEmail(email: string) {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (!emailRegex.test(email)) {
    return { valid: false, reason: 'validated:email' };
  }
  return { valid: true };
}

export function validateExternalId(data: string, type: string | null): ValidationResult {
  if(!data) return {valid: true};
  switch (type) {
    case 'isbn':
      const regexpIsbn: RegExp = new RegExp('^(97([89]))?[0-9]{9}([0-9]|X)$');
      if (!regexpIsbn.test(data.replaceAll('-', ''))) {
        return {valid: false, reason: `validated:invalidFormat:${type}`};
      }
      break;
    case 'doi':
      const regexpDoi: RegExp = new RegExp('^10\\.[0-9]{2,}(?:\\.[0-9]+)*/(?![%"#? ])\\S');
      if (!regexpDoi.test(data)) {
        return {valid: false, reason: `validated:invalidFormat:${type}`};
      }
      break;
    default:
      return {valid: true};
  }
  return {valid: true};
}
